// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CloudOutlinedSvg from "@ant-design/icons-svg/es/asn/CloudOutlined";
import AntdIcon from '../components/AntdIcon';

var CloudOutlined = function CloudOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: CloudOutlinedSvg
  }));
};

CloudOutlined.displayName = 'CloudOutlined';
export default React.forwardRef(CloudOutlined);